import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "decimalToComma" })
export class DecimalToCommaPipe implements PipeTransform {
  transform(value: number, precision: number): string {
    if (precision === 0) {
      return value.toString();
    }

    const formattedValue = value.toFixed(precision);
    return formattedValue.replace(".", ",");
  }
}
